import { logAction } from "../core/services/logs";

export default function Logger({ op, id, children, className }) {
  const logMe = (e) => {
    if (!e.currentTarget.classList.contains("logger")) {
      logAction(op, id);
      e.currentTarget.className += " logger";
    }
  };

  return (
    <div className={className} onMouseEnter={(e) => logMe(e)}>
      {children}
    </div>
  );
}
